<template>
    <div class="grid">
        <div class="col-6">
            <PairsTable :items="sortedPairsOne" :compact="compact" :select="handleSelect"/>
        </div>
        <div class="col-6">
            <PairsTable :items="sortedPairsTwo" :compact="compact" :select="handleSelect"/>

        </div>
    </div>
</template>

<script>
import helperMethods from '@/helpers'
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import PairsTable from "@/Menu/PairsTable";

export default {
    props:{
        items: Array,
        compact: Boolean,
        select: Function,
    },
    components:{
        DataTable, Column, PairsTable
    },
    data(){
        return {
            selectedItem: null,
        }
    },
    computed:{
        sortedPairs(){
            return this.items.sort((a, b) => {
                return a.pair_name.localeCompare(b.pair_name);
            });
        },
        sortedPairsOne(){
            // return this.sortedPairs.filter((item, i) => {
            //     return i % 2 === 0;
            // });
            var half = Math.ceil(this.sortedPairs.length / 2);
            return this.sortedPairs.slice(0, half);

        },
        sortedPairsTwo(){
            // return this.sortedPairs.filter((item, i) => {
            //     return i % 2 !== 0;
            // });
            var half = Math.ceil(this.sortedPairs.length / 2);
            return this.sortedPairs.slice(half);
        },
    },
    methods:{
        ...helperMethods,
        handleSelect(item){
            this.select(item)
        },
        handleSelectTwo(item){
            this.select(item)
        },
    },
    mounted(){
        // console.log(this.sortedPairsOne)
        // console.log(this.sortedPairsTwo)
    }
}
</script>
